import ReactECharts from "echarts-for-react";
import type { UptimeBlock } from "@/lib/dashboardApi";
import { OperatorPanel } from "@/components/admin/dashboard/OperatorPanel";

export function UptimeSparkline({ data }: { data: UptimeBlock }): JSX.Element {
  const isOk = data.status === "ok";
  return (
    <OperatorPanel
      testId="platform-health-uptime"
      kicker="Reliability"
      title="Uptime (90d)"
      headerRight={
        !isOk ? (
          <span
            data-testid="badge-unavailable-uptime"
            className="rounded bg-surface-canvas px-2 py-0.5 text-2xs text-text-tertiary"
          >
            Better Stack unavailable
          </span>
        ) : undefined
      }
    >
      {isOk && data.sparkline.length > 0 ? (
        <ReactECharts
          option={{
            grid: { top: 8, left: 8, right: 8, bottom: 8 },
            xAxis: { type: "category", show: false, data: data.sparkline.map((_, i) => i) },
            yAxis: { type: "value", show: false, min: 90, max: 100 },
            series: [{ type: "line", data: data.sparkline, symbol: "none" }],
          }}
          style={{ height: 80 }}
        />
      ) : (
        <p className="text-sm text-text-secondary">
          {data.percent === null ? "No data" : `${data.percent.toFixed(2)}%`}
        </p>
      )}
    </OperatorPanel>
  );
}
